<!-- mobile component -->
<div class="breadcrumb">
  <a [routerLink]="['/tools/categories', catalogCode]" [ngClass]="{'current': !breadcrumb && !currentCategory}">{{ catalogName }}</a>
  @if (breadcrumb && currentCategory) {
    <div class="breadcrumb-data">
      <span class="separator">/</span>
      @for (category of breadcrumb; track category) {
        <div class="breadcrumb-elements">
          <a [routerLink]="['/tools/categories', catalogCode, category.id]" [innerHtml]="category.name | safe: 'html'"> </a>
          <span class="separator">/</span>
        </div>
      }
      <span [innerHtml]="currentCategory | safe: 'html'"></span>
    </div>
  }
</div>